module.exports = __webpack_public_path__ + "img/homeSec03bg1.c64407a2.jpg";